
import { defineComponent } from 'vue';
import { $api } from '@/common/apiService'


export default defineComponent ({
    name: "AdminUtilities",
    data() {
        return {
            loading: false,
            thumbnailMessage: "",
            passwordMessage: "" as String,
            newPassword: ""
        }
    },
    methods: {
        async generateThumbnails() {
            this.loading = true;
            this.thumbnailMessage = await $api.images.generateThumbnails();
            this.loading = false;
        },
        async setPasswords() {
            this.loading = true;
            this.passwordMessage = await $api.users.setPasswords(this.newPassword.toString());
            this.loading = false;
        }
    }
});
